<template>
  <section>
    <div class="local-lm-filters">
      <b-field
        class="lm-label"
      >
        <b-input
          v-model.trim="orderBO"
          type="text"
          :placeholder="$t('OrderBOFilter.labelPlaceholder')"
          class="local-lm-filters--input"
          :disabled="disabled"
          @input="sendOrderBO"
        />
      </b-field>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OrderBoFilter',
  data () {
    return {
      orderBO: null,
      disabled: false
    }
  },
  mounted () {
    this.$eventBus.$on('cleanFilters', this._cleanFilters)
    this.$eventBus.$on('openFilter', this._openFilter)
  },
  beforeDestroy () {
    this.$eventBus.$off('cleanFilters', this._cleanFilters)
    this.$eventBus.$off('openFilter', this._openFilter)
  },
  methods: {
    sendOrderBO () {
      const toogleFocus = this.orderBO || false

      this.$store.dispatch('filters/setOrderBOSelected', this.orderBO)
      this.$eventBus.$emit('writeOrder', toogleFocus)
    },
    _openFilter () {
      this.disabled = true
    },
    _cleanFilters () {
      this.orderBO = null
      this.disabled = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderBoFilter.vue